import React from "react";
import { pullCanvasserEvents } from "../../../store/api/calls";
import Moment from "moment";
import { startCase } from "lodash";
import RowCard from "../../cards/rowCard";
import ImageThumbnail from "../../imgs/thumbnail";
import CanvasserEventsTimeline from "../charts/canvasserEventsTimeline";
import { getEventColorStyle } from "../../../utils/eventColors";
import { connect } from "react-redux";
import { Checkbox, FormControlLabel, Box } from "@mui/material";

const GapWarningLine = ({ minutes }) => {
  return <div className={"gap-warning-line"}>{minutes} Minute Gap</div>;
};

class DataTimeline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalData: false,
      canvasser_id: this.props.canvasser.canvasser_id || this.props.canvasser.canvasser_id_2,
      showLocationUpdates: true,
      showEvents: true,
    };
  }

  componentDidMount() {
    if (this.state.canvasser_id) {
      this.showEventsModal();
    }    
  }

  showEventsModal = (d) => {
    const params = {
      campaign: this.props.focusedCampaign.id,
      start: new Moment(this.props.dashboardParams.start).format("YYYY-MM-DD"),
      end: new Moment(this.props.dashboardParams.end).format("YYYY-MM-DD"),
      canvasser: this.state.canvasser_id,
      details: 1,
      showEvents: this.state.showEvents,
      showLocationUpdates: this.state.showLocationUpdates,
    };
    if (this.props.dashboardParams.selectedOffice > 0) {
      params.office = this.props.dashboardParams.selectedOffice;
    }
    if (this.props.dashboardParams.selectedRoute > 0) {
      params.route = this.props.dashboardParams.selectedRoute;
    }
    if (this.props.dashboardParams.selectedShift > 0) {
      params.shift = this.props.dashboardParams.selectedShift;
    }
    pullCanvasserEvents(params).then((data) => {
      if (!data) return;
      let processed_data = data
        .sort((a, b) => (a.phone_time > b.phone_time ? 1 : -1))
        .map((d) => ({ ...d, color: getEventColorStyle(d.event_type) }));

      this.setState({
        modalData: processed_data,
      });
    });
  };

  handleFilterChange = (filterType) => {
    this.setState(prevState => {
      const newState = {
        [filterType]: !prevState[filterType]
      };
      
      // If both filters would be false after this change, set both to true
      const otherFilterType = filterType === 'showEvents' ? 'showLocationUpdates' : 'showEvents';
      const otherFilterValue = prevState[otherFilterType];
      const newFilterValue = newState[filterType];
      
      if (!newFilterValue && !otherFilterValue) {
        newState.showEvents = true;
        newState.showLocationUpdates = true;
      }
      
      return newState;
    }, () => {
      // Trigger new API call with updated filters
      this.showEventsModal();
    });
  };


  makeResponseHTML = (element) => {
    if (!element.response || !element.response.length)
      return <span>{element.status || "--"}</span>;

    const filterResponseForMedia = (d) => !!d.media_src;

    // we need to sort out the media files from the text;
    let text_responses = element.response.filter(
      (d) => !filterResponseForMedia(d)
    );
    let media_responses = element.response.filter((d) =>
      filterResponseForMedia(d)
    );
    
    // If no text or media responses, show "--"
    if (!text_responses.length && !media_responses.length) {
      return <span>--</span>;
    }
    
    return (
      <div>
        {!!text_responses.length && (
          <div>{text_responses.map((d) => d.response).join(", ")}</div>
        )}
        {!!media_responses.length && (
          <div className={"flx"}>
            {media_responses.map((d) => (
              <ImageThumbnail src={d.media_thumb_src || d.media_src} largeSrc={d.media_src} />
            ))}
          </div>
        )}
      </div>
    );
  };

  renderRowCards = () => {
    let rowCards = this.state.modalData.map((d, idx, arr) => {
      let columns = [
        {
          title: "Event Type",
          text: `${startCase(d.event_type)}`,
          textStyle: { fontSize: ".7em" },
        },
        {
          title: "Time",
          text: `${new Moment(d.phone_time).format("MM/DD LT")}`,
          textStyle: { fontSize: ".7em" },
        },
      ];

      if (d.door) {
        columns.push({
          title: "Site/Door",
          text: `${d.door.street_address_1}`,
          textStyle: { fontSize: ".7em" },
        });
      } else if (d.site) {
        columns.push({
          title: "Site/Door",
          text: <div>
            <div style={{fontWeight:600}}>{d.site.name}</div>
            <div style={{fontSize:'90%', fontWeight:400}} >
                {d.site.addressline1} {d.site.addressline2} <br />
                {d.site.city}, {d.site.statecode} {d.site.zip5}
            </div>
          </div>,
          textStyle: { fontSize: ".7em" },
        });
      } else if (["training_start", "training_end"].includes(d.event_type)) {
        columns.push({
          title: "Trainee",
          text: d?.ex_info?.trainee_name || "--",
          textStyle: { fontSize: ".7em" },
        });
      } else {
        columns.push({
          title: "Site/Door",
          text: "--",
          textStyle: { fontSize: ".7em" },
        });
      }

      columns.push({
        title: "Response",
        html: this.makeResponseHTML(d),
        // text: `${(d.response && d.response.length) ? d.response.map((d) => d.response).join(", ") : d.status ? d.status : '--'}`,
        textStyle: { fontSize: ".7em" },
      });

      let gap_to_next = 0;
      if (idx < arr.length - 1) {
        gap_to_next = Moment(arr[idx + 1].phone_time).diff(
          Moment(d.phone_time),
          "minutes"
        );
      }
      return (
        <>
          <RowCard
            color={getEventColorStyle(d.event_type, d.status)}
            key={d.id}
            columns={columns}
          />
          {gap_to_next > 15 && <GapWarningLine minutes={gap_to_next} />}
        </>
      );
    });

    return rowCards;
  };

  isWidowGreaterThan24Hours = () => {
    if (this.state.modalData.length < 2) return false;
    try {
      const start = new Moment(this.state.modalData[0].phone_time);
      const end = new Moment(
        this.state.modalData[this.state.modalData.length - 1].phone_time
      );

      return start.add(24, "hours").isBefore(end);
    } catch {
      return false;
    }
  };

  render() {

    if (!this.state.canvasser_id) return "Canvasser has no data";
    if (!this.state.modalData) return "loading timeline data...";
    if (this.state.modalData.length == 0) return "no timeline data.";

    return (
      <React.Fragment>
         <Box sx={{ marginBottom: "10px", display: "flex", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.showEvents}
                  onChange={() => this.handleFilterChange('showEvents')}
                  color="primary"
                />
              }
              label="Events"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.showLocationUpdates}
                  onChange={() => this.handleFilterChange('showLocationUpdates')}
                  color="primary"
                />
              }
              label="Location Updates"
            />
          </Box>
        <div className={"card"}>
          <h6 style={{ marginBottom: "-20px" }}>Timeline</h6>        
          <CanvasserEventsTimeline
            data={this.state.modalData}
            long={this.isWidowGreaterThan24Hours()}
          />
        </div>
        {this.renderRowCards()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  dashboardParams: state.dashboardParams,
  focusedCampaign: state.session.focusedCampaign,
});

export default connect(mapStateToProps, null)(DataTimeline);
